import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  Button,
  Chip,
  FormControl,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Snackbar,
} from "@mui/material";
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import { getUserDetails } from '../../../../src/storageService';
import { postleaverequest, getAllleaverequest } from '../../../Utils/apiService';

const statusColors = {
  'Approved': { background: '#D6E8D6', color: '#256029' },
  'In review': { background: '#FDEBC8', color: '#805B00' },
  'Pending': { background: '#FDEBC8', color: '#805B00' },
  'Denied': { background: '#F2C2C2', color: '#7A1E1E' },
  'Rejected': { background: '#F2C2C2', color: '#7A1E1E' },
};

const LeaveRequests = () => {
  const [open, setOpen] = useState(false);
  const [leaveType, setLeaveType] = useState('Exception');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [noOfDays, setNoOfDays] = useState('');
  const [reason, setReason] = useState('');

  const [leaveRequests, setLeaveRequests] = useState<any[]>([]);
  const [filteredRequests, setFilteredRequests] = useState<any[]>([]);
  const [statusFilter, setStatusFilter] = useState('');

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>('success');

  const user = getUserDetails();
  const contactId = user?.ContactId;

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const fetchLeaveRequests = async () => {
    if (!contactId) return;
    try {
      const response = await getAllleaverequest(contactId);
      const leaves = Array.isArray(response?.leaves) ? response.leaves : [];
  
      setLeaveRequests(leaves);
      setFilteredRequests(leaves);
    } catch (error) {
      console.error("Error fetching leave requests:", error);
      setLeaveRequests([]);
      setFilteredRequests([]);
    }
  };
  useEffect(() => {
    fetchLeaveRequests();
  }, [contactId]);

  const handleFilterChange = (event: any) => {
    const selected = event.target.value;
    setStatusFilter(selected);
    if (!selected) {
      setFilteredRequests(leaveRequests);
    } else {
      const filtered = leaveRequests.filter((req: any) => req.status === selected);
      setFilteredRequests(filtered);
    }
  };

  const handleSubmit = async () => {
    if (!contactId || !fromDate || !toDate || !noOfDays || !reason) {
      setSnackbarMessage('Please fill all fields');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      fromDate,
      toDate,
      noOfDays: Number(noOfDays),
      reason,
      leaveType,
      studentId: contactId,
    };

    try {
      await postleaverequest(payload, contactId);
      setSnackbarMessage('Leave request submitted!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setOpen(false);

      // Clear form
      setFromDate('');
      setLeaveType('');
      setToDate('');
      setNoOfDays('');
      setReason('');

      // Refresh data
      fetchLeaveRequests();
    } catch (err) {
      console.error('Failed to submit leave request:', err);
      setSnackbarMessage('Failed to submit. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  return (
    <Paper style={{ padding: '20px' }}>
      <Box className="leave-wrapper">
        <Box className="leave-card">
          <Box
            className="leave-header"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h5" className="leave-title">
              All requests
            </Typography>

            <Box className="leave-actions" sx={{ display: 'flex', alignItems: 'center' }}>
              <FormControl size="small" sx={{ marginRight: '16px' }}>
                <Select
                  value={statusFilter}
                  onChange={handleFilterChange}
                  displayEmpty
                  className="leave-select"
                >
                  <MenuItem value="">Select status</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="In review">In review</MenuItem>
                  <MenuItem value="Denied">Denied</MenuItem>
                </Select>
              </FormControl>

              <Button variant="contained" className="leave-button" onClick={() => setOpen(true)}>
                Request time off
              </Button>
            </Box>
          </Box>

          <TableContainer component={Paper} elevation={0} style={{ marginTop: '20px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="leave-head">Applied on</TableCell>
                  <TableCell className="leave-head underline">Leave dates</TableCell>
                  <TableCell className="leave-head">Leave type</TableCell>
                  <TableCell className="leave-head">Number of Days</TableCell>
                  <TableCell className="leave-head">Status</TableCell>
                  <TableCell className="leave-head">Reason</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
  {filteredRequests.length === 0 ? (
    <TableRow>
      <TableCell colSpan={6} align="center">
        No leaves found
      </TableCell>
    </TableRow>
  ) : (
    filteredRequests.map((row: any, i: number) => (
      <TableRow key={i}>
        <TableCell style={{fontWeight: '400'}}>{row.appliedOn || '-'}</TableCell>
        <TableCell style={{fontWeight: '400'}}>{`${row.fromDate} - ${row.toDate}`}</TableCell>
        <TableCell style={{fontWeight: '400'}}>{row.leaveType || '-'}</TableCell>
        <TableCell style={{fontWeight: '400'}}>{row.noOfDays}</TableCell>
        <TableCell style={{fontWeight: '400'}}>
          <Chip
            label={row.status}
            sx={{
              backgroundColor: statusColors[row.status as keyof typeof statusColors]?.background || '#eee',
              color: statusColors[row.status as keyof typeof statusColors]?.color || '#333',
              fontWeight: 500,
              borderRadius: '16px',
              px: 1.5,
              py: 0.5,
              fontSize: '0.8rem',
            }}
          />
        </TableCell>
        <TableCell style={{fontWeight: '400'}}>{row.reason}</TableCell>
      </TableRow>
    ))
  )}
</TableBody>

            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogContent sx={{ p: 4, backgroundColor: 'white', borderRadius: '20px' }}>
          <Typography variant="h5" fontWeight={600} mb={2}>
            Apply for Leave of Absence
          </Typography>

          <Typography fontSize="14px" fontWeight={500} mb={1}>
            Leave type
          </Typography>
          <FormControl>
            <RadioGroup row value={leaveType} onChange={(e) => setLeaveType(e.target.value)}>
              <FormControlLabel value="Exception" control={<Radio sx={{ color: '#2196F3' }} />} label="Exception" />
              <FormControlLabel value="Personal leave" control={<Radio />} label="Personal leave" />
            </RadioGroup>
          </FormControl>

          <Typography fontSize="14px" fontWeight={500} mt={2} mb={1}>
            From Date
          </Typography>
          <TextField fullWidth type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} sx={{ mb: 2 }} />

          <Typography fontSize="14px" fontWeight={500} mb={1}>
            To Date
          </Typography>
          <TextField fullWidth type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} sx={{ mb: 2 }} />

          <Typography fontSize="14px" fontWeight={500} mb={1}>
            Number of Days
          </Typography>
          <TextField fullWidth value={noOfDays} onChange={(e) => setNoOfDays(e.target.value)} placeholder="2" sx={{ mb: 2 }} />

          <Typography fontSize="14px" fontWeight={500} mb={1}>
            Reason
          </Typography>
          <TextField fullWidth multiline rows={4} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Describe" sx={{ mb: 3 }} />

          <DialogActions sx={{ justifyContent: 'space-between', px: 0 }}>
            <Button onClick={() => setOpen(false)} sx={{ textTransform: 'none', backgroundColor: '#F3F4F6', borderRadius: 2, px: 3 }}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit} sx={{ background: 'linear-gradient(to right, #2196F3, #00C6FF)', textTransform: 'none', borderRadius: 2, px: 3 }}>Submit</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* Snackbar */}
      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Paper>
  );
};

export default LeaveRequests;
